"use strict";
/* globals module */
/**
 * @module templatingBatchClient
 * @description  Templating Batch Client provides an easy way to consume  Templating REST API end-points. In order to obtain a needed routes `templatingBatchClient` uses `templatingBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var TemplatingBatchClient = /** @class */ (function () {
    function TemplatingBatchClient(templatingBatchRoute, apiClient) {
        this.templatingBatchRoute = templatingBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(TemplatingBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.templatingBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates new template resources.
     * @method
     * @param data An Template objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create action has been performed.
     * @example templatingBatchClient.create([{ content : '<content>', templateId : '<template-id>' }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
    **/
    TemplatingBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified template resources.
     * @method
     * @param data An Template objects that need to be inserted into the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example templatingBatchClient.update(templates)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove template resources from the system if successfully completed.
     * @method
     * @param ids Template ids which uniquely identify Template resources that need to be deleted.
     * @returns A promise that is resolved once the update action has been performed.
     * @example templatingBatchClient.remove(companyIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.templatingBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    TemplatingBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.TemplatingBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.TemplatingBatchRoute !== "undefined" && _1.TemplatingBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], TemplatingBatchClient);
    return TemplatingBatchClient;
}());
exports.TemplatingBatchClient = TemplatingBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
